// utils/SweetAlertComponent.js
import swal from "sweetalert";
import { GetSelectedLanguage } from "../helper/Method";
import { t } from "i18next";
export const SweetAlertComponent = ({ messageKey, statusCode }) => {
  const isUrdu = GetSelectedLanguage() !== "en";

  let icon = "info"; // default

  switch (statusCode) {
    case "200":
      icon = "success";
      break;
    case "201":
      icon = "info";
      break;
    case "300":
      icon = "warning";
      break;
    case "400":
    default:
      icon = "error";
      break;
  }

  swal({
    title: t(messageKey),
    className: isUrdu ? "ur" : "",
    icon: icon,
    buttons: isUrdu ? "ٹھیک ہے" : "OK",
  });
};
